export default __webpack_public_path__ + "static/media/emoji-orange.006848cf.svg";